import { PayloadAction } from '@reduxjs/toolkit';
import { assert_not_null } from '@shared/asserts/utils_asserts';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { FN_SLICE__grid2d_recreate } from '../_methods/FN_SLICE__grid2d_recreate';
import { STATE__grid2d } from '../STATE__grid2d';

export const local_grid2d_update_partial = (payload: Partial<DTO__grid2d>[]): PayloadAction<Partial<DTO__grid2d>[]> => ({
  type: ENUM__redux_action.GRID2D_UPDATE_PARTIAL,
  payload,
});

export const init_local_grid2d_update_partial = (state: STATE__grid2d, action: PayloadAction<Partial<DTO__grid2d>[]>) => {
  let items = action.payload;

  if (items.is_empty()) return;

  for (let item of items) {
    let grids2d_map = state.grids2d_map;

    assert_not_null(item._id);

    let grid2d = grids2d_map.get(item._id);
    if (!grid2d) continue; //not loaded yet

    for (let [key, value] of Object.entries(item) as [keyof DTO__grid2d, any][]) {
      if (DTO__grid2d.KEYS_RESTRICTED_FOR_PARTIAL_UPDATE.includes(key)) continue;

      (grid2d as any)[key] = value;
    }
  }

  //refresh map to trigger re-render
  FN_SLICE__grid2d_recreate(state);
};
